import { css, injectGlobal } from '@emotion/css'
import { fontFamily, fontSize, fontWeight, breakpoint, spacing, shorthandHelper, mediaQueryHelper, colors } from '@offerzen/pinata-shame'

export const globalStyles = {
  '*, *::after, *::before': {
    boxSizing: 'inherit',
  },
  html: {
    boxSizing: 'border-box',
  },
  body: {
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    lineHeight: 1.2,
    margin: 0,
    color: colors.jumbo,
    backgroundColor: colors.catskillWhite,
  },

  strong: {
    fontWeight: fontWeight.semiBold,
  },
}
injectGlobal(globalStyles)

const styles = {
  systemError: css({
    '& > div': {
      padding: shorthandHelper([spacing.default, spacing.medium]),
      width: '100%',
      margin: 'auto',

      [mediaQueryHelper(breakpoint.desktop)]: {
        width: breakpoint.desktop,
      },
    },
  }),
}

export default styles
